import { reactive, ref, watch } from 'vue';
import type { TeamAthlete, TeamAthleteProfile } from '@/types/athletes';

export interface UseChangePositionDialogState {
  isOpen: boolean;
  athlete: TeamAthlete | TeamAthleteProfile | null;
  defaultAcademicYearUuid: string | null;
}

const DEFAULT_STATE: UseChangePositionDialogState = {
  isOpen: false,
  athlete: null,
  defaultAcademicYearUuid: null,
};

const getDefaultState = () => ({ ...DEFAULT_STATE });

const state = reactive<UseChangePositionDialogState>(getDefaultState());

function resetState() {
  Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
  if (isOpen && !isRendered.value) isRendered.value = true;
  if (!isOpen) resetState();
});

export function useChangePositionDialog() {
  async function open(
    athlete: TeamAthlete | TeamAthleteProfile,
    defaultAcademicYearUuid: string | null = null,
  ) {
    state.athlete = athlete;
    state.defaultAcademicYearUuid = defaultAcademicYearUuid;
    state.isOpen = true;
  }

  return {
    state,
    isRendered,
    resetState,
    open,
  };
}
